import React from 'react'
import AboutImage from './AboutImage'
import AboutText from './AboutText'
import AboutHeroSection from './AboutHeroSection'
import Objectives from '../../pages/Objectives/Objectives'
import Blog from '../../pages/Blog/Blog'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'

const About = () => {
  return (
    <div>
      <AboutImage/>
      <AboutText/>
      <AboutHeroSection/>
      <Objectives/>
      <Blog/>
      <Scroll/>
      <Footer/>
    </div>
  )
}

export default About
